import styled, { css } from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import RichText from '../base/richText';
import RichTextTitle from '../base/richTextTitle';
import Button from '../button-v2';

export const Root = styled.div`
	margin-top: 150px;
`;

export const RichTextTitleStyled = styled(RichTextTitle)`
	margin-bottom: 32px;
`;

export const RichTextConditionalStyled = styled(RichText)``;

export const DetailsBlock = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
`;

export const ButtonStyled = styled(Button)`
	margin-top: 18px;
	display: inline-flex;
`;

export const AccordionImage = styled.img`
	width: 100%;
	margin: 0 auto 48px;
	max-height: 550px;
	border-radius: 16px;
	flex: 1;

	${media.desktopSmall`
		max-width: 50%;
		max-height: 500px;
	`}
`;

export const AccordionBlock = styled.div<{ hasImage: boolean }>`
	margin-top: 56px;
	flex: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 2rem;
	padding: 1rem;

	${media.desktopSmall`
		margin-top: ${({ hasImage }) => (hasImage ? '18px' : '0')};
	`}
`;

export const AccordionLine = styled.div`
	border-radius: 8px;
	border: 1px solid ${theme.colorsV2.grey4};
	transition: 200ms ease;

	&:hover {
		box-shadow: 0px 0px 30px 0px #00000014;
	}
`;

export const Line1 = styled.div`
	width: 16px;
	height: 1.5px;
	border-radius: 9999px;
	background-color: ${theme.colorsV2.mainPink};
	transition: background-color 200ms, transform 400ms;
`;

export const Line2 = styled.div`
	position: absolute;
	height: 16px;
	width: 1.5px;
	border-radius: 9999px;
	background-color: ${theme.colorsV2.mainPink};
	transition: background-color 200ms, transform 400ms;
	transform-origin: center;
`;

export const IconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	flex-shrink: 0;
	width: 2.2rem;
	height: 2.2rem;
	margin-left: 1.5rem;
	transition: transform 200ms;
`;

export const AccordionTrigger = styled.button<{ active: boolean }>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-inline: 3rem;
	color: ${theme.colorsV2.mainDark};
	font-family: ${theme.fonts.ArimoRegular};
	cursor: pointer;
	transition: color 150ms ease, border 200ms ease;
	background-color: inherit;
	font-size: 20px;
	line-height: 26px;
	text-align: left;
	letter-spacing: inherit;
	width: 100%;
	min-height: 78px;

	&:hover {
		color: ${theme.colorsV2.mainRed};
	}

	${({ active }) =>
		active &&
		css`
			${Line1} {
				transform: rotate(-180deg);
			}

			${Line2} {
				transform: rotate(90deg);
			}
		`};
`;

export const RichTextStyled = styled(RichText)`
	margin-top: -5px;
	padding-bottom: 24px;
	padding-inline: 3rem;
	color: ${theme.colorsV2.grey7};
	max-height: 320px;
	overflow-y: auto;

	${media.desktopSmall`
		max-height: none;
	`};
`;
interface AccordionContainerProps {
	horizontal: boolean;
	hasImage: boolean;
  }

  export const AccordionContainer = styled.div<AccordionContainerProps>`
	display: flex;
	flex-direction: ${({ hasImage }) => (hasImage ? 'column-reverse' : 'column')};
	${RichTextConditionalStyled} + ${AccordionImage} {
		margin-top: 32px;
	}
	${RichTextConditionalStyled} + ${ButtonStyled},
	${AccordionImage} + ${ButtonStyled} {
		margin-top: 50px;
	}
	${AccordionBlock} {
		margin-top: ${({ horizontal }) => !horizontal && '24px'};
	}

	align-items: start;

	${media.desktopSmall`
		display: flex;
		flex-direction: column;
		max-width: 784px;
		margin-inline: auto;

		${({ horizontal }) =>
			horizontal &&
			css`
				flex-direction: row;
				gap: 3rem;
				max-width: unset;
				margin-inline: unset;
			`};

		${({ horizontal }) =>
			!horizontal &&
			css`
				${DetailsBlock} {
					align-items: normal;
				}
				${RichTextTitleStyled} {
					text-align: center;
				}
			`};
	`};
`;

export const AccordionItemTitle = styled.span`
	padding: 1rem 0;
`;
